import React from 'react';
import './VideoSection.css';

function VideoSection() {
    return (
        <section className="video-section" id="video-tutorial">
            <div className="video-container">
                <div className="video-section-title">
                    <h6>TUTORIAL</h6>
                    <h3>Aprende a usar la herramienta</h3>
                    <p>Mira nuestro video tutorial para conocer cómo utilizar la Evaluación Laboral de manera efectiva.</p>
                </div>
                <div className="video-wrapper">
                    <iframe
                        src="https://www.youtube.com/embed/oW2S2xRNw4k"
                        title="Tutorial Evaluación Laboral"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                    ></iframe>
                </div>
            </div>
        </section>
    );
}

export default VideoSection;
